import { useState, useEffect } from "react";
import styles from "./StoriesBar.module.css";
import BlockedScrollPopup from "../ChatComponents/BlockedScrollPopup";
import selfAvatarFallback from "../../assets/feed/perfil-sem-foto.jpeg";
import av1 from "../../assets/feed/av-fallback-1.jpg";
import av2 from "../../assets/feed/av-fallback-2.jpg";
import av3 from "../../assets/feed/av-fallback-3.jpg";
import av4 from "../../assets/feed/av-fallback-4.jpg";
import av5 from "../../assets/feed/av-fallback-5.jpg";
import av6 from "../../assets/feed/av-fallback-6.jpg";
import av7 from "../../assets/feed/av-fallback-7.jpg";
import av8 from "../../assets/feed/av-fallback-8.jpg";
import av9 from "../../assets/feed/av-fallback-9.jpg";
import av10 from "../../assets/feed/av-fallback-10.jpg";

// Array de fallback com avatares locais
const fallbackAvatars = [av1, av2, av3, av4, av5, av6, av7, av8, av9, av10];

const STORIES_FALLBACK = [
  { name: "Pe*****", type: "locked", avatar: av1 },
  { name: "Lo*****", type: "locked", avatar: av2 },
  { name: "Sw*****", type: "locked", avatar: av3 },
  { name: "En*****", type: "locked", avatar: av4 },
  { name: "La*****", type: "locked", avatar: av5 },
  { name: "Jo*****", type: "locked", avatar: av6 },
  { name: "Th*****", type: "locked", avatar: av7 },
  { name: "Be*****", type: "locked", avatar: av8 },
  { name: "So*****", type: "locked", avatar: av9 },
  { name: "Le*****", type: "locked", avatar: av10 },
  { name: "Ma*****", type: "locked", avatar: av1 },
  { name: "Ga*****", type: "locked", avatar: av2 },
  { name: "Is*****", type: "locked", avatar: av3 },
  { name: "Ra*****", type: "locked", avatar: av4 },
  { name: "Lu*****", type: "locked", avatar: av5 },
  { name: "Ca*****", type: "locked", avatar: av6 },
  { name: "Vi*****", type: "locked", avatar: av7 },
  { name: "Fe*****", type: "locked", avatar: av8 },
  { name: "Na*****", type: "locked", avatar: av9 },
  { name: "Di*****", type: "locked", avatar: av10 },
];

// Função para censurar username no formato xxx*****
function maskUsername(username) {
  if (!username || username.length === 0) return '***';
  const firstChar = username[0].toLowerCase();
  return `${firstChar}${'*'.repeat(5)}`;
}

export default function StoriesBar() {
  const [showPopup, setShowPopup] = useState(false);
  const [storiesData, setStoriesData] = useState(STORIES_FALLBACK);

  const profile = JSON.parse(localStorage.getItem('current_profile') || '{}');
  const selfAvatar = profile.profileImageUrl || selfAvatarFallback;

  // Carregar dados reais do localStorage
  useEffect(() => {
    try {
      // CORRIGIDO: Buscar dados de FOLLOWING (pessoas que o perfil SEGUE)
      // Prioridade: chaining_results (following) > instagram_following > followers (último fallback)
      const followingData = localStorage.getItem('chaining_results') 
        || localStorage.getItem('instagram_following')
        || localStorage.getItem('followers');
      
      if (followingData) {
        const parsed = JSON.parse(followingData);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // AUMENTADO: Pegar 20 usuários para preencher a tela
          const shuffled = [...parsed].sort(() => Math.random() - 0.5).slice(0, 20);
          setStoriesData(shuffled);
          return;
        }
      }
      
      // Se não encontrou dados válidos, usar fallback
      setStoriesData(STORIES_FALLBACK);
    } catch (e) {
      console.error('Erro ao carregar stories:', e);
      // Em caso de erro, usar fallback
      setStoriesData(STORIES_FALLBACK);
    }
  }, []);

  return (
    <>
      <section className={styles.storiesWrapper}>
        <div className={styles.storiesContainer}>

          {/* SEU STORY */}
          <div className={styles.storyItem}>
            <button className={styles.storyButton} onClick={() => setShowPopup(true)}>
              <div className={`${styles.storyRing} ${styles.self}`}>
                <div className={styles.storyAvatar}>
                  <img src={selfAvatar} alt="Seu story" />
                </div>
                <div className={styles.addStory}>
                  <span>+</span>
                </div>
              </div>
            </button>
            <span className={styles.storyUsername}>Seu story</span>
          </div>

          {/* STORIES COM FOTOS REAIS */}
          {storiesData.map((story, index) => (
            <div className={styles.storyItem} key={index}>
              <button className={styles.storyButton} onClick={() => setShowPopup(true)}>
                <div className={`${styles.storyRing} ${index >= 15 ? styles.locked : ''}`}>
                  <div className={styles.storyAvatar}>
                    <img 
                      src={story.profile_pic_url || story.avatar} 
                      alt={story.username || story.name}
                      onError={(e) => {
                        e.target.src = fallbackAvatars[index % fallbackAvatars.length];
                      }}
                    />
                  </div>
                  {/* Ícone de cadeado nos últimos 5 stories (índices 15-19 de 20 total) */}
                  {index >= 15 && (
                    <div className={styles.lockIcon}>
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 17a2 2 0 100-4 2 2 0 000 4zm6-9a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h1V6a5 5 0 0110 0v2h1zm-6-5a3 3 0 00-3 3v2h6V6a3 3 0 00-3-3z"/>
                      </svg>
                    </div>
                  )}
                </div>
              </button>
              <span className={styles.storyUsername}>
                {maskUsername(story.username || story.name)}
              </span>
            </div>
          ))}

        </div>
      </section>

      <BlockedScrollPopup
        show={showPopup}
        onClose={() => setShowPopup(false)}
        title="🔒 Story bloqueado"
        description="Seja um membro VIP do PinkStalker para visualizar stories"
      />
    </>
  );
}
